import ViewHelpers from '../../core/utils/view.helpers';
import AttributesModel from '../../core/models/AttributesModel';
import ValidationsService from '../../services/validations.service';

export default class AttributesComponent {
	constructor() {
		this.template = require('./jf-attributes.view.html');
		this.controller = AttributesController;
		this.bindings = {
			dao: '<',
			daoParams: '<',
			attributeList: '=', // model
			keyPlaceholder: '@',
			valuePlaceholder: '@',
			editable: '<',
			validations: '<?',
			noDeleteConfirmation: '<?',
			onAfterAddValue: '&?',
			onAfterDeleteValue: '&?',
			allowDuplicacy: '<?',
			newAttributeName: '=?',
			newAttributeValue: '=?'
		};
	}
}

AttributesComponent.META = {
	name: 'attributesList'
};

class AttributesController {
	constructor(JFrogTableViewOptions, JFrogModal, validationsService, $element,$scope) {
		this.stringifyData = ViewHelpers.stringifyData;
		this.JFrogTableViewOptions = JFrogTableViewOptions;
		this.JFrogModal = JFrogModal;

		this.getAttributes();

		this.newAttributeIsValid = true;
		this.newAttributeValidationError = 'Attribute already exists';
		this.validationsService = validationsService;
		this.$element = $element;

		$scope.$watch('$ctrl.newAttributeName', () => {
			this.onNewAttributeChange();
		});
	}

	getAttributes() {
		if (!this.dao) {
			this.attributeList = this.attributeList || [];
			return;
		}
		this.dao.Resource.getList(this.daoParams).$promise
		    .then((result) => {
			    this.attributeList = result;
		    });
	}

	newAttributeNameIsValid() {
		return this.newAttributeName && this.newAttributeValue && this.newAttributeIsValid && this.addCustomAttribute.$valid;
	}

	onNewAttributeChange() {
		if (!this.newAttributeName || !this.dao) {
			this.newAttributeIsValid = true;
			return;
		}

		// Server side validation
		let attributeToCheck = new AttributesModel({name: this.newAttributeName, values: []});
		this.dao.Resource.checkIfAttributeExists(this.daoParams, attributeToCheck.build()).$promise
		    .then((res) => {
			    this.newAttributeIsValid = false;
		    }, (err) => {
			    this.newAttributeIsValid = true;
		    });
	}

	onSubmitNewAttributeForm() {
		if ((!this.newAttributeName && !this.newAttributeValue) || !this.newAttributeNameIsValid()) {
			return;
		}
		let attributeToCreate = new AttributesModel({name: this.newAttributeName, values: this.newAttributeValue});
		if (!this.dao) {
			if (!this.allowDuplicacy && _.find(this.attributeList, attr => attr.name === this.newAttributeName)) {
				this.newAttributeIsValid = false;
				return;
			}
			return this.addToList(attributeToCreate);
		}
		// Save changes
		this.dao.Resource.create(this.daoParams, attributeToCreate.build()).$promise.then(() => {
			this.addToList(attributeToCreate);
		});
	}

	resetFocus() {
		this.$element.find('input#name').focus();
	}

	addToList(attributeToCreate) {
		this.attributeList.push(attributeToCreate);
		this.newAttributeName = '';
		this.newAttributeValue = '';
		if (this.onAfterAddValue && typeof this.onAfterAddValue === 'function') {
			this.onAfterAddValue();
		}
		this.resetFocus();
	}

	onAttributeEdit(attribute) {
		attribute.tempValue = attribute.values;
		attribute.beingEdited = true;
	}

	onAttributeCancelEdit(attribute) {
		attribute.beingEdited = false;
		attribute.tempValue = attribute.values;
	}

	onUpdateAttribute(attribute) {
		attribute.beingEdited = false;

		if (!this.dao) {
			attribute.values = attribute.tempValue;
			return;
		}

		let attributeToUpdate = new AttributesModel({name: attribute.name, values: attribute.tempValue});
		// Do update call to save the changes
		this.dao.Resource.updateAttribute(this.daoParams, attributeToUpdate.build()).$promise
		    .then(() => {
			    attribute.values = attribute.tempValue;
		    });
	}

	onAttributeDelete(attribute) {
		if (this.noDeleteConfirmation) {
			this._deleteAttribute(attribute);
		} else {
			this.JFrogModal.confirm('Delete attribute ' + attribute.name + ' ?', 'Delete Attribute',
				{confirm: 'Delete'})
			    .then(() => {
				    this._deleteAttribute(attribute);
			    });
		}
	}

	_deleteAttribute(attribute) {
		if (!this.dao) {
			this._removeAttrFromList(attribute);
			return;
		}
		let attributeToDelete = new AttributesModel({name: attribute.name, values: attribute.values});
		// Delete and save the changes
		this.dao.Resource.deleteAttribute(this.daoParams, attributeToDelete.build()).$promise
		    .then(() => {
			    this._removeAttrFromList(attribute);
		    });
	}

	_removeAttrFromList(attribute) {
		_.remove(this.attributeList, (attr) => {
			return attr.name === attribute.name && attr.values === attribute.values;
		});

		if (this.onAfterDeleteValue && typeof this.onAfterDeleteValue === 'function') {
			this.onAfterDeleteValue();
		}
	}

	canEditAttribute(attribute) {
		if (!this.dao) {
			return !attribute.beingEdited;
		}
		return (!attribute.beingEdited) && attribute.hasWritePermission;
	}
}

AttributesController.$inject = [
	'JFrogTableViewOptions',
	'JFrogModal',
	ValidationsService.META.name,
	'$element',
	'$scope'
];


// WEBPACK FOOTER //
// ./modules/distribution/directives/jf-attributes/jf-attributes.component.js